<h4>Click on <button class="btn btn-info" (click)="tryRegister()">Register</button> to create the regiter of application</h4>

<div *ngIf="error" class="alert alert-danger">
  {{error}}
</div>
